import { Type } from "@sinclair/typebox";
export const UploadSessionSchema = Type.Object({
    token: Type.String(),
    upload_url: Type.String(),
    date_expires: Type.String({ format: "date-time" }),
    constraints: Type.Object({
        max_files: Type.Optional(Type.Union([Type.Null(), Type.Number()])),
        max_file_size: Type.Optional(Type.Union([Type.Null(), Type.Number()])),
        match_exts: Type.Array(Type.String()),
        not_match_exts: Type.Array(Type.String()),
    }),
});
